export class CampoPersonalizadoItem {
  id: number;
  idCampoPersonalizado: number;
  descricao: string;
  excluir: boolean;
}
